import { ServiceWorkOrderPlanningFilterKeys } from '../service-work-order/service-work-order-planning-filter-keys';

/**
 * TypeScript twin of the backend `ServiceWorkOrderStepPlanningFilterKeys` constants
 * (Digiwall.GoliathDocuments.Planning, Domain.Shared). The planned entity is a `WorkOrderStepLine`, so
 * these carry every parent-document filter of the base ServiceWorkOrder source (reused verbatim) plus
 * the step-line specific ones (StepName / Equipment / Worker). These strings are the FE↔BE contract —
 * a wrong key silently no-ops (the backend applier ignores unknown keys), so keep both sides in sync.
 */
export const ServiceWorkOrderStepPlanningFilterKeys = {
  // Parent ServiceWorkOrderDoc filters (reused from the base source).
  dayBook: ServiceWorkOrderPlanningFilterKeys.dayBook,
  customer: ServiceWorkOrderPlanningFilterKeys.customer,
  interventionType: ServiceWorkOrderPlanningFilterKeys.interventionType,
  article: ServiceWorkOrderPlanningFilterKeys.article,
  description: ServiceWorkOrderPlanningFilterKeys.description,
  displayNumber: ServiceWorkOrderPlanningFilterKeys.displayNumber,
  // Step-line specific filters.
  stepName: 'StepName',
  equipment: 'Equipment',
  worker: 'Worker',
} as const;

export type ServiceWorkOrderStepPlanningFilterKey =
  (typeof ServiceWorkOrderStepPlanningFilterKeys)[keyof typeof ServiceWorkOrderStepPlanningFilterKeys];

/** Dropdown (multi-select) filters — the only ones allowed to carry preset values. */
export const SERVICE_WORK_ORDER_STEP_DROPDOWN_KEYS: ServiceWorkOrderStepPlanningFilterKey[] = [
  ServiceWorkOrderStepPlanningFilterKeys.dayBook,
  ServiceWorkOrderStepPlanningFilterKeys.customer,
  ServiceWorkOrderStepPlanningFilterKeys.interventionType,
  ServiceWorkOrderStepPlanningFilterKeys.article,
  ServiceWorkOrderStepPlanningFilterKeys.equipment,
  ServiceWorkOrderStepPlanningFilterKeys.worker,
];

/** Free-text filters — client-side substring only, never carry preset values. */
export const SERVICE_WORK_ORDER_STEP_TEXT_KEYS: ServiceWorkOrderStepPlanningFilterKey[] = [
  ServiceWorkOrderStepPlanningFilterKeys.description,
  ServiceWorkOrderStepPlanningFilterKeys.displayNumber,
  ServiceWorkOrderStepPlanningFilterKeys.stepName,
];
